import { useState } from 'react';
import { ChevronDown, X, CircleCheckBig } from 'lucide-react';
import './TabNav.css';

function renderTabIcon(tab) {
    if (!tab?.icon) return null;
    return typeof tab.icon === 'string' ? <i className={tab.icon}></i> : tab.icon;
}

export default function TabNav({
    tabs,
    activeTab,
    onTabChange,
    noMarginBottom = false,
}) {
    const [sheetOpen, setSheetOpen] = useState(false);
    const wrapperClass = `tab-nav ${noMarginBottom ? 'tab-nav--no-margin' : ''}`;

    const activeIndex = tabs.findIndex((t) => t.id === activeTab);
    const activeTabObj = activeIndex >= 0 ? tabs[activeIndex] : null;

    const handlePick = (id) => {
        onTabChange(id);
        setSheetOpen(false);
    };

    return (
        <>
            {/* Desktop / tablet — linha de abas horizontal */}
            <div className={wrapperClass}>
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        onClick={() => onTabChange(tab.id)}
                        className={`btn-tab ${activeTab === tab.id ? 'btn-tab--active' : ''}`}
                    >
                        {tab.icon && <span className="tab-icon">{renderTabIcon(tab)}</span>}
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* Mobile — gatilho que abre a seleção de seção em bottom sheet */}
            <button
                type="button"
                className="tabnav-trigger"
                onClick={() => setSheetOpen(true)}
                aria-haspopup="dialog"
                aria-expanded={sheetOpen}
            >
                <span className="tabnav-trigger-icon">{renderTabIcon(activeTabObj)}</span>
                <span className="tabnav-trigger-text">
                    <span className="tabnav-trigger-eyebrow">Seção atual</span>
                    <span className="tabnav-trigger-label">{activeTabObj?.label}</span>
                </span>
                {tabs.length > 0 && (
                    <span className="tabnav-trigger-count">{activeIndex + 1} de {tabs.length}</span>
                )}
                <ChevronDown size={18} className="tabnav-trigger-chevron" />
            </button>

            {sheetOpen && (
                <>
                    <div className="tabnav-sheet-overlay" onClick={() => setSheetOpen(false)} />
                    <section className="tabnav-sheet" role="dialog" aria-modal="true" aria-labelledby="tabnav-sheet-title">
                        <div className="tabnav-sheet-handle" />
                        <div className="tabnav-sheet-header">
                            <div>
                                <h2 id="tabnav-sheet-title" className="tabnav-sheet-title">Seções</h2>
                                <p className="tabnav-sheet-subtitle">Escolha o que deseja configurar</p>
                            </div>
                            <button
                                type="button"
                                className="tabnav-sheet-close"
                                onClick={() => setSheetOpen(false)}
                                aria-label="Fechar"
                            >
                                <X size={20} />
                            </button>
                        </div>
                        <div className="tabnav-sheet-list">
                            {tabs.map((tab, i) => {
                                const active = activeTab === tab.id;
                                return (
                                    <button
                                        key={tab.id}
                                        type="button"
                                        aria-current={active ? 'step' : undefined}
                                        className={`tabnav-sheet-item ${active ? 'tabnav-sheet-item--active' : ''}`}
                                        onClick={() => handlePick(tab.id)}
                                    >
                                        <span className="tabnav-sheet-item-icon">{renderTabIcon(tab)}</span>
                                        <span className="tabnav-sheet-item-label">{tab.label}</span>
                                        <span className="tabnav-sheet-item-index">{i + 1}</span>
                                        {active && <CircleCheckBig size={17} className="tabnav-sheet-item-check" />}
                                    </button>
                                );
                            })}
                        </div>
                    </section>
                </>
            )}
        </>
    );
}
